"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inview = exports.inscreen = exports.lazyLoad = void 0;
var inscreen_observer_1 = __importDefault(require("@finn-no/inscreen-observer"));
function lazyLoad(element, callback, options) {
    if (typeof window === 'object') {
        var observer_1 = new inscreen_observer_1.default(callback, __assign({ once: true }, options));
        if (element && observer_1) {
            observer_1.observe(element);
            return function cleanup() {
                observer_1.unobserve(element);
            };
        }
    }
    return function cleanup() { };
}
exports.lazyLoad = lazyLoad;
function inscreen(element, callback, options) {
    return lazyLoad(element, callback, __assign({ threshold: 0.5 }, options));
}
exports.inscreen = inscreen;
function inview(element, callback, proximity) {
    if (proximity === void 0) { proximity = 100; }
    return lazyLoad(element, callback, {
        proximity: proximity,
    });
}
exports.inview = inview;
